import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlusMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPlusMedium"><Path d="M11.25 12.75H4.5V11.25H11.25V4.5H12.75V11.25H19.5V12.75H12.75V19.5H11.25V12.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlusMedium;
